import axios from "axios";
import bridge from "@vkontakte/vk-bridge";
import {store} from "@/store";
import config from "@/config";

export const offline = {
  methods: {
    checkOffline() {
      const state = store.state;
      let params = {
        'user_vk_id': parseInt(state.launchParams["vk_user_id"]),
        'url': state.launchURL
      };
      axios.post(config["endpoint"] + "/api/check-offline", params)
        .then(() => {
          if (state.isOffline === true) {
            this.$store.commit("setIsOffline", false);
          }
        })
        .catch(() => {
          store.commit("setIsOffline", true);
        });
    },
    restoreFormCache(callback, params = {}) {
      bridge.subscribe(({ detail: { type } }) => {
        if (type === "VKWebAppViewRestore") {
          callback(params);
          this.checkOffline();
        }
      });
    }
  },
  computed: {
    isOffline: function() {
      return this.$store.state.isOffline;
    }
  },
  watch: {
    isOffline: function() {
      // template
    }
  }
};
